import ru from 'plotly.js-locales/ru';
import en from 'plotly.js-locales/uk';

export default {
  ru,
  en
};
